import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Tooltip } from '@mui/material';
import { getCityTypeIcon, getCityTypeLabel } from '../functions';
import { useTranslation } from 'react-i18next';

const CityIcon = ({ type }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={getCityTypeLabel(t, type)}>
      <Icon color='primary'>{getCityTypeIcon(type)}</Icon>
    </Tooltip>
  );
};

CityIcon.propTypes = {
  type: PropTypes.string
};

export default CityIcon;
